import { giveProductsOf } from "./giveProductsOf";

export const giveProductsOfSize = giveProductsOf("size");
